import script from "./ScheduleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ScheduleCard.vue?vue&type=script&setup=true&lang=js"

import "./ScheduleCard.vue?vue&type=style&index=0&id=a9fe73d2&lang=scss"

const __exports__ = script;

export default __exports__